import Link from "next/link"
import {
  type BrandSliderConfig,
  getBrandSliderCtaText,
} from "./brand-slider-config"

interface Props {
  slider: BrandSliderConfig
}

/**
 * The text block of a brand slide: name, description and CTA. The
 * homepage carousel and the Collection Launcher's preview both draw it.
 */
export function BrandSlideTitle({ slider }: Props) {
  const brandPageUrl = slider.url ?? `/${slider.slug}`

  return (
    <div className="flex flex-col gap-2">
      {slider.showNewBrandLabel ? (
        <div className="flex items-center gap-2 text-brand">
          <svg
            width="6"
            height="6"
            viewBox="0 0 6 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Brand status</title>
            <circle cx="3" cy="3" r="3" fill="currentColor" />
          </svg>
          <span>New brand</span>
        </div>
      ) : null}
      <h1 className="font-bold text-white text-xl leading-tight md:text-2xl">
        <span className={slider.mobileName ? "hidden md:inline" : undefined}>
          {slider.name}
        </span>
        {slider.mobileName ? (
          <span className="md:hidden">{slider.mobileName}</span>
        ) : null}
      </h1>
      <p className="max-w-lg text-[11px] text-white/80 leading-snug md:text-xs">
        <span
          className={slider.mobileDescription ? "hidden md:inline" : undefined}
        >
          {slider.description}
        </span>
        {slider.mobileDescription ? (
          <span className="md:hidden">{slider.mobileDescription}</span>
        ) : null}
      </p>
      <Link
        href={brandPageUrl}
        target={slider.openCtaInNewTab ? "_blank" : undefined}
        rel={slider.openCtaInNewTab ? "noopener noreferrer" : undefined}
        className="relative z-30 mt-2 w-fit rounded-lg bg-white px-5 py-2 font-medium text-black text-sm transition-opacity hover:opacity-90"
        onClick={(e) => e.stopPropagation()}
      >
        {getBrandSliderCtaText(slider)}
      </Link>
    </div>
  )
}
